import styled from 'styled-components';

import { theme } from '../../global-styles/colors';

export const OverlayViewDiv = styled.div`
  width: 125px;
  height: 32px;
  border-radius: 6px;
  background-color: ${theme.type.primary};
  color: ${theme.neutrals.white};
  position: absolute;
  padding: 8px;
  font-size: 12px;
  font-weight: 400;
  text-align: center;
  line-height: 0;
  display: flex;
  align-items: center;
  top: 10px;
  right: 10px;
`;

export const GoogleMapsStyles = styled.div`
  position: relative;

  .gm-fullscreen-control {
    right: auto !important;
  }

  /*======= Map Styling ============*/
  .gmnoprint a,
  .gmnoprint span {
    display: none;
  }
  .gmnoprint {
    display: none;
  }
  #GMapsID div div a div img {
    display: none;
  }
`;

export const CenterMarkerStyle = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
  height: 30px;
  width: 30px;
  pointer-events: none;

  img {
    width: 100%;
    height: 100%;
  }
`;

export const GeolocationButtonStyle = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border: none;
  border-radius: 2px;
  background-color: ${theme.neutrals.white};
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  color: #5f6368;
  transition: background-color 0.2s ease;

  &:hover:not(:disabled) {
    background-color: #f5f5f5;
    color: #1a73e8;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const PermissionInfoStyle = styled.div`
  position: absolute;
  top: 58px;
  right: 10px;
  z-index: 10;
  max-width: 220px;
  padding: 8px 12px;
  border-radius: 4px;
  background-color: ${theme.neutrals.white};
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.25);
  font-size: 12px;
  color: ${theme.type.primary};
  line-height: 1.4;

  &.denied {
    border-left: 3px solid ${theme.status.error.medium};
  }

  &.prompt {
    border-left: 3px solid ${theme.status.info.info_signal};
  }
`;
